// 申请寄样枚举定义

import UltMeta, { Meta } from './UltMeta/index';

/**
 * 状态
 */
class SampleApplyState extends UltMeta {
    PENDING = new Meta(1, '待处理');
    SHIPPED = new Meta(2, '已寄出');
    INVALID_INFORMATION = new Meta(3, '无效信息');
}

export const SAMPLE_APPLY_STATE = new SampleApplyState();
